var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-flex"},[_c('div',{staticClass:"flex-group"},[_c('router-link',{staticClass:"no-line",attrs:{"to":"/"}},[_c('h2',{staticClass:"nav-title"},[_vm._v(_vm._s(_vm.title))])]),_vm._v(" "),_c('typeahead',{staticClass:"search-input",attrs:{"searched-text":_vm.initialSearch,"default-text":_vm.placeholder}})],1),_vm._v(" "),_c('menu-toggle',{staticClass:"menu"})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0767aa84","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/Components/NavSearch.vue
// module id = 48
// module chunks = 0